import { Fragment, ReactNode, useMemo } from "react";
import { UseDatepickerProps, FocusedInput } from "@datepicker-react/hooks";
import { Popover, Transition } from "@headlessui/react";
import CVAModal from "components/modals/common/CVAModal";
import Divider from "components/utilities/Divider";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
import Datepicker from "../datepicker";
interface DateRangeInputGeneralProps extends UseDatepickerProps {
  isDateSelected?: boolean;
  isOpen: boolean;
  isVacationRentalPage?: boolean;
  modalFooter?: ReactNode;
  modalHeader?: ReactNode;
  onClose: () => void;
  onFocusChange: (FocusedInput: FocusedInput) => void;
  onOpen?: () => void;
  onReset?: () => void;
  popoverStyle?: string;
  vertical?: boolean;
  afterCalendar?: ReactNode;
  beforeCalendar?: ({
    handleDateReset,
    onClose
  }: {
    handleDateReset?: () => void;
    onClose?: () => void;
  }) => ReactNode;
  isDisplayClearDates?: boolean;
}
const DateRangeInputGeneral = (props: DateRangeInputGeneralProps) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const {
    isOpen,
    onClose,
    onOpen,
    startDate,
    endDate,
    minBookingDate,
    maxBookingDate,
    focusedInput,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    onDatesChange,
    initialVisibleMonth,
    vertical = false,
    onReset = () => {},
    modalHeader,
    modalFooter,
    popoverStyle = "",
    afterCalendar,
    beforeCalendar,
    isDisplayClearDates = false
  } = props;
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  const calendar = useMemo(() => {
    return <Datepicker isAnnotated={false} onReset={onReset} onClose={onClose} startDate={startDate} endDate={endDate} minBookingDate={minBookingDate} maxBookingDate={maxBookingDate} focusedInput={focusedInput} onDatesChange={onDatesChange} vertical={vertical} initialVisibleMonth={initialVisibleMonth} annotatedCalendarDates={undefined}
    // show all months [ which are included in booking range ] in mobile view calendar
    activeMonths={undefined} afterCalendar={afterCalendar} beforeCalendar={beforeCalendar} isDisplayClearDates={isDisplayClearDates} />;
  }, [onReset, onClose, startDate, endDate, minBookingDate, maxBookingDate, focusedInput, onDatesChange, vertical, initialVisibleMonth, afterCalendar, beforeCalendar]);
  return <>
      {isLargerThan992 ?
    // desktop date input
    <Popover as='div' className='relative'>
          <Popover.Button className='outline-none'>
            <div aria-label='calender' role='button' tabIndex={0} />
          </Popover.Button>
          <Transition as={Fragment} show={isOpen}>
            <div>
              <Popover.Overlay className='fixed inset-0 bg-transparent' onClick={onClose} />
              <Popover.Panel id='DateInputGeneral' className={`absolute z-[12!important] rounded-lg bg-offWhite pb-2 shadow-[0_1px_2px_0_#0000000d] ${popoverStyle}`}>
                <main className='pb-2'>{calendar}</main>
              </Popover.Panel>
            </div>
          </Transition>
        </Popover> : <CVAModal isOpen={isOpen} onClose={() => onOpen && onOpen()} intent={"modal"} size={"fullScreen"} isCloseIcon={false} classNameDialog='z-[9999!important]'>
          {modalHeader && <header className='fixed top-0 z-[1] w-full p-0'>
              {modalHeader}
              <Divider />
            </header>}
          <div className={`h-[calc(100vh_-_58px_-_120px)] w-full overflow-auto px-4 ${modalHeader ? "pt-[60px]" : "pt-0 "}`}>
            {calendar}
          </div>
          {modalFooter && <div className='fixed bottom-0 block w-full p-0'>
              <Divider />
              {modalFooter}
            </div>}
        </CVAModal>}
    </>;
};
export default DateRangeInputGeneral;